import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import getFileExtension from "src/shared/helpers/get-file-extension";

import axios from "../../../src/core/api/axiosClientCert";

const initialState: any = {
  certificates: [],
  isLoadingCertificates: false,
  certificateStatus: [],
  isLoadingCertificateStatus: false,
  restrictCertificates: [],
  revokeCertificates: [],
  revokeCommonCertificates: [],
  renewCertificates: [],
  filter: {},
  isLoading: false,
  isLoadingCommonCertificate: false,
  error: null,
};

export const addCommonCertificate: any = createAsyncThunk(
  "content/addCommonCertificate",
  async ({ payload }: any) => {
    const res = await axios.post(
      `/dmscertificate/CommonCertificate/insert`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await res.data;
    return data;
  }
);

export const getCertificates: any = createAsyncThunk(
  "content/getCertificates",
  async ({
    PageNumber: pageNum,
    pageSize,
    deviceCode,
    status,
    fromDate,
    toDate,
    searchText,
    SortBy,
    SortDirection,
  }: any) => {
    const res = await axios.get(`/dmscertificate/Certificate/GetAll`, {
      params: {
        pageNum,
        pageSize,
        deviceId: deviceCode,
        status,
        fromDate,
        toDate,
        searchText,
        SortBy,
        SortDirection,
      },
    });
    const data = await res?.data;

    return data;
  }
);

export const getCertificateStatus: any = createAsyncThunk(
  "content/getCertificateStatus",
  async () => {
    const res = await axios.get("/dmscertificate/Certificate/Status");
    const data = await res?.data?.data;

    return data;
  }
);

export const restrictCertificate: any = createAsyncThunk(
  "content/restrictCertificate",
  async ({ certificateId }: any) => {
    const res = await axios.put(
      `/dmscertificate/Certificate/Restrict`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: { certificateId },
      }
    );

    const data = await res.data;
    return data;
  }
);

export const enableCertificate: any = createAsyncThunk(
  "content/enableCertificate",
  async ({ certificateId }: any) => {
    const res = await axios.put(
      `/dmscertificate/Certificate/Enable`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: { certificateId },
      }
    );

    const data = await res.data;
    return data;
  }
);

export const revokeCertificate: any = createAsyncThunk(
  "content/revokeCertificate",
  async ({ certificateId }: any) => {
    const res = await axios.put(
      `/dmscertificate/Certificate/Revoke`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: { certificateId },
      }
    );

    const data = await res?.data;
    return data;
  }
);

// export const revokeCommonCertificate: any = createAsyncThunk(
//   "content/revokeCommonCertificate",
//   async ({ Id }: any) => {
//     const res = await axios.put(
//       `/dmscommoncertificate/revokecommoncertificate`,
//       {},
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//         params: { Id },
//       }
//     );

//     const data = await res?.data;
//     return data;
//   }
// );

export const revokeCommonCertificate: any = createAsyncThunk(
  "content/revokeCommonCertificate",
  async ({ commonName }: any) => {
    const res = await axios.post(
      `/dmscertificate/CommonCertificate/revokecommoncertificate`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: { commonName },
      }
    );

    const data = await res?.data;
    return data;
  }
);

export const regenarateCommonCertificate: any = createAsyncThunk(
  "content/regenarateCommonCertificate",
  async ({ payload }: any) => {
    const res = await axios.post(
      `/dmscertificate/CommonCertificate/regeneratecommoncertificate`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await res.data;
    return data;
  }
);

export const renewCertificate: any = createAsyncThunk(
  "content/renewCertificate",
  async ({ payload }: any) => {
    try {
      const response = await axios.post(
        `/dmscertificate/Certificate/RenewCertificate`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "arraybuffer",
        }
      );

      /* let contentDisposition = response.headers["content-disposition"];
      // debugger;

      // const contentDisposition =
      //   "attachment; filename=ota_file-SJ-version-7.zip; filename*=UTF-8''ota_file-SJ-version-7.zip";

      let filename = contentDisposition
        .split(";")
        .map((part: string) => part.trim())
        .find(
          (part: string) =>
            part.startsWith("filename=") || part.startsWith("filename*=")
        )
        ?.split("=")[1];

      const fileBlob = new Blob([response.data], {
        type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = `${
        "Certificate_" + payload?.expireDate.replace(/-/g, "_") + ".zip"
      }`;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data; */

      const data = response.data;
      const contentType: any = response.headers["content-type"];
      let contentDisposition = response.headers["content-disposition"];

      let filename = contentDisposition
        .split(";")
        .map((part: string) => part.trim())
        .find(
          (part: string) =>
            part.startsWith("filename=") || part.startsWith("filename*=")
        )
        ?.split("=")[1];

      // Remove the quotes if they exist
      if (filename) {
        filename = filename.replace(/^['"]|['"]$/g, "");
        filename = filename.replace(/(\.zip|\.tar)$/, "");
      }

      const fileBlob = new Blob([data], {
        type: contentType,
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = filename + getFileExtension(contentType);

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading Device Cerrtificates:", error);
      throw error;
    }
  }
);

export const getDeviceCertificateFile: any = createAsyncThunk(
  "content/getDeviceCerrtificates",
  async ({ certificateId }: any) => {
    try {
      const response = await axios.get(
        `/dmscertificate/Certificate/DownloadCertificate`,
        {
          params: { certificateId },
          responseType: "arraybuffer", // Ensure response is treated as binary data
        }
      );

      const data = response.data;
      const contentType: any = response.headers["content-type"];
      let contentDisposition = response.headers["content-disposition"];

      // const contentDisposition =
      //   "attachment; filename=ota_file-SJ-version-7.zip; filename*=UTF-8''ota_file-SJ-version-7.zip";

      let filename = contentDisposition
        .split(";")
        .map((part: string) => part.trim())
        .find(
          (part: string) =>
            part.startsWith("filename=") || part.startsWith("filename*=")
        )
        ?.split("=")[1];

      // Remove the quotes if they exist
      if (filename) {
        filename = filename.replace(/^['"]|['"]$/g, "");
        filename = filename.replace(/(\.zip|\.tar)$/, "");
      }

      const fileBlob = new Blob([data], {
        type: contentType,
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = filename + getFileExtension(contentType);

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading Device Cerrtificates:", error);
      throw error;
    }
  }
);

export const getCommonCertificateFile: any = createAsyncThunk(
  "content/getCommonCertificateFile",
  async ({ commonName }: any) => {
    try {
      const response = await axios.get(
        `/dmscertificate/CommonCertificate/downloadcommoncertificate`,
        {
          params: { commonname: commonName },
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const fileBlob = new Blob([response.data], {
        type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = `${commonName + ".zip"}`;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading Device Cerrtificates:", error);
      throw error;
    }
  }
);

export const getCommonDownloadCertificateFile: any = createAsyncThunk(
  "content/getCommonDownloadCertificateFile",
  async () => {
    try {
      const response = await axios.get(
        `/dmscertificate/Certificate/CommonCertificate`,
        {
          params: {},
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      let contentDisposition = response.headers["content-disposition"];
      // debugger;

      const fileBlob = new Blob([response.data], {
        type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = `${"Common Certificate" + ".zip"}`;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading Device Cerrtificates:", error);
      throw error;
    }
  }
);

export const certificateSlice = createSlice({
  name: "certificate",
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addCommonCertificate.pending, (state) => {
      state.isLoadingCommonCertificate = true;
    });
    builder.addCase(addCommonCertificate.fulfilled, (state, action) => {
      state.isLoadingCommonCertificate = false;
    });
    builder.addCase(addCommonCertificate.rejected, (state, action) => {
      state.isLoadingCommonCertificate = false;
      state.error = action.error.message;
    });

    builder.addCase(getCertificates.pending, (state) => {
      state.isLoadingCertificates = true;
    });
    builder.addCase(getCertificates.fulfilled, (state, action) => {
      state.isLoadingCertificates = false;
      state.certificates = action.payload;
    });
    builder.addCase(getCertificates.rejected, (state, action) => {
      state.isLoadingCertificates = false;
      state.error = action.error.message;
    });

    builder.addCase(getCertificateStatus.pending, (state) => {
      state.isLoadingCertificateStatus = true;
    });
    builder.addCase(getCertificateStatus.fulfilled, (state, action) => {
      state.isLoadingCertificateStatus = false;
      state.certificateStatus = action.payload;
    });
    builder.addCase(getCertificateStatus.rejected, (state, action) => {
      state.isLoadingCertificateStatus = false;
      state.error = action.error.message;
    });

    builder.addCase(restrictCertificate.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(restrictCertificate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.restrictCertificates = action.payload;
    });
    builder.addCase(restrictCertificate.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(revokeCertificate.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(revokeCertificate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.revokeCertificates = action.payload;
    });
    builder.addCase(revokeCertificate.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(revokeCommonCertificate.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(revokeCommonCertificate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.revokeCommonCertificates = action.payload;
    });
    builder.addCase(revokeCommonCertificate.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(renewCertificate.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(renewCertificate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.renewCertificates = action.payload;
    });
    builder.addCase(renewCertificate.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});
export const { setFilter } = certificateSlice.actions;

export default certificateSlice.reducer;
